module.exports = __webpack_public_path__ + "img/0499e6_6beb477088e046069d13b5588ad21757_mv2.2d3f6e91.webp";